import React,{useEffect} from 'react';
import {List, ListItem, Paper} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useDispatch, useSelector} from "react-redux";
import {useAuthUser, useIsAuthenticated} from "react-auth-kit";
import {isDealerSite} from "../../../utils/utils";
import {getActivityList} from "../../../redux/actions/activitiesActions";
import {setTotalActivitiesFH} from "../../../redux/actions/totalActions";
import {format, parse} from "date-fns";

const Summary = () => {
    const totals = useSelector(state => state.totalsExtras);
    // const activities = useSelector(state => state.activities);
    const {extra:selectedExtras} = useSelector(state => state.transactions);
    const auth = useAuthUser();
    const isAuth = useIsAuthenticated();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setTotalActivitiesFH())
    }, []);

    return (
        <Paper className={'summaryContainer'} elevation={3} style={{marginTop: 20}}>
        <List style={{width: '100%', paddingBottom: 0, paddingTop: 0}}>
            {totals.activityItems && totals.activityItems.length > 0 && totals.activityItems.map((item, index) =>
                <ListItem key={index} alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h6" component="h6" align="left">
                                {format(parse(item.date, "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'LLL d')} - {format(parse(item.date, "yyyy-MM-dd'T'HH:mm:ss", new Date()), 'h:mm a')} > {item.activity} x{item.pax}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${(item.subtotal).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
            )}
            {totals.activitiesAmount > 0 &&
                <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                Subtotal Activities
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${(totals.activitiesAmount).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
            {totals.taxes > 0 &&
                <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                Taxes ({totals.tax * 100}%)
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${(totals.taxes).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
            {isDealerSite() && isAuth() && totals.total > 0 && auth().commission>0 &&
                <ListItem alignItems={"flex-start"} style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                Commission ({auth().commission * 100}%)
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                ${((totals.total) * auth().commission).formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
            {totals.total > 0 &&
                <ListItem alignItems={"flex-start"}
                          style={{paddingTop: 12, paddingBottom: 12, margin: 0}}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="left">
                                <strong>Total</strong>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="right">
                                <strong>${(isDealerSite() && isAuth() ? totals.total - (totals.total * auth().commission) : totals.total).formatMoney(2)}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>}
        </List>
    </Paper>
    );
};

export default Summary;
